<template>
    <b-modal ref="bank-api-login-input-view-modal" :title="$t('action.enterBankLoginAndPassword')"
             @ok="save($event)"
             :ok-title="$t('common.transferMoney')"
             :no-close-on-backdrop="true"
             :no-close-on-esc="true"
             :ok-disabled="!showSmsCode">
        <div class="">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col col-12">
                            <Loading2 v-if="loading"></Loading2>
                            <div class="form-group">
                                <label>{{$t('common.login')}}: <span class="red">*</span></label>
                                <input type="text" class="form-control"
                                       v-model="loginForm.login"
                                       :placeholder="$t('common.login')"
                                       :class="{invalid : $v.loginForm.login.$error}">
                                <div class="red" v-if="$v.loginForm.login.$error">
                                    {{$t('common.login')}}
                                </div>
                            </div>
                        </div>
                        <div class="col col-12">
                            <div class="form-group">
                                <label>{{$t('common.password')}}: <span class="red">*</span></label>
                                <input type="password" class="form-control" :placeholder="$t('common.password')"
                                       v-model="loginForm.password"
                                       :class="{invalid : $v.loginForm.password.$error}">
                                <div class="red" v-if="$v.loginForm.password.$error">
                                    {{$t('common.password')}}
                                </div>
                            </div>
                        </div>
                        <div class="col col-12">
                            <div class="row align-items-center justify-content-center">
                                <div class="col col-sm-5 pr-0">
                                    <div class="form-group" v-show="smsField && showSmsCode">
                                        <!--<label>{{$t('common.smsCode')}}: <span class="red">*</span></label>-->
                                        <input type="text" class="form-control"
                                               v-model="loginForm.smsCode"
                                               minlength="8"
                                               maxlength="8"
                                               max="8"
                                               min="8"
                                               :placeholder="$t('common.smsCode')"
                                               :class="{invalid : $v.loginForm.smsCode.$error}">
                                        <div class="red" v-if="$v.loginForm.smsCode.$error">
                                            {{$t('common.smsCode')}}
                                        </div>
                                        <div class="red" v-if="!$v.loginForm.smsCode.minLength">
                                            Узунлиги 8 тадан кам булмаслиги керак
                                        </div>
                                        <div class="red" v-if="!$v.loginForm.smsCode.maxLength">
                                            Узунлиги 8 тадан куп булмаслиги керак
                                        </div>
                                    </div>
                                </div>
                                <div class="col col-sm-7" style="line-height: 10px">
                                    <div class="form-group font-weight-bold" style="font-size: 14px" v-if="loginForm.login && loginForm.password && readyToSend">
                                        <label>{{$t('finance.field.yourMobileNumber')}}:</label><br/>
                                        <span>{{profile.mobilePhone}}</span>
                                    </div>
                                    <div class="form-group" v-if="loginForm.login && loginForm.password && readyToSend">
                                        <button class="all-btn add-btn ml-3" @click="sendSms($event)"
                                                :disabled="false">
                                            {{$t("action.sendSms")}}
                                        </button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group" v-show="smsField && showSmsCode">
                                        <BaseTimerView @input="finishedTime" :timeLimit="60"
                                                       v-if="!loading"></BaseTimerView>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>

</template>

<script>
    // import {required, /*requiredUnless, requiredIf*/} from 'vuelidate/lib/validators';
    import {required, minLength, maxLength, requiredUnless/*minValue, minLength*/} from 'vuelidate/lib/validators';
    import initFilterModel from '@/shared/filter';
    import Loading2 from "@/views/Loading2";
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import BaseTimerView from "@/views/common/BaseTimerView";
    import {mapState} from 'vuex';



    export default {
        name: "BankApiLoginInputView",
        components: {
            Loading2,
            bModal,
            BaseTimerView
        },
        props: {
            placeholder: String,
            value: Object,
            smsField: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                regionFilter: initFilterModel(),
                focused: false,
                addressValue: null,
                showModalTable: false,
                loginForm: {
                    login: null,
                    password: null,
                    smsCode: null
                },
                loading: false,
                changeable: true,
                showSmsCode: false,
                readyToSend: true
            }
        },
        mounted() {
            // console.log(this.parentData);
            setTimeout(() => {
                console.log(this.$props.value);
                if (this.$props.value) {
                    this.loginForm = this.$props.value;
                }
            }, 1000);

        },
        validations() {
            return {
                loginForm: {
                    login: {
                        required: required,
                        minLength: minLength(4)
                    },
                    password: {
                        required: required,
                        minLength: minLength(4)
                    },
                    smsCode: {
                        required: requiredUnless(() => {
                            return this.hasField();
                        }),
                        minLength: minLength(8),
                        maxLength: maxLength(8)
                    },
                }
            }
        },
        methods: {
            hasField() {
                return !this.showSmsCode;
            },
            save($event) {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    $event.preventDefault();
                    return;
                }
                this.loading = true;
                this.$emit('input', this.loginForm);
                // this.$eventBus.$emit('refreshFixedExpenseTypeList', this.loginForm);
            },
            sendSms($event) {
                this.showSmsCode = false;

                this.$v.$touch();
                if (this.$v.$invalid) {
                    $event.preventDefault();
                    return;
                }
                this.loading = true;
                this.readyToSend = false;

                this.$http.post('/accountant/ipoteka-payment-transaction/send-sms', this.loginForm)
                    .then(res => {
                        console.log(res);
                        if (res.data.status==="SUCCESS") {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: res.data.message,
                                type: 'success'
                            });
                            this.showSmsCode = true;
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.ipotekaPaymentTransaction.error') + ' ' + res.data.message,
                                type: 'error'
                            });
                            this.showSmsCode = false;
                            this.readyToSend = true;
                        }
                        this.loading = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.ipotekaPaymentTransaction.error'),
                            type: 'error'
                        });
                        this.loading = false;
                        this.showSmsCode = false;
                        this.readyToSend = true;
                    });

            },
            finishedTime(data){
                console.log(data);
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('messages.ipotekaPaymentTransaction.timeUp'),
                    type: 'warning'
                });
                this.readyToSend = true;
                this.showSmsCode = false;
                // this.$router.push('/finance/ipoteka/payment-list');
            }
        },
        created() {
            this.$eventBus.$on('showBankApiLoginInputView', (/*data*/) => {
                // console.log(data);
                this.loginForm = {};
                this.changeable = true;
                this.$refs['bank-api-login-input-view-modal'].show();

            });
        },
        computed: {
            ...mapState(['profile']),
        },
        watch: {

        }
    }
</script>

<style scoped>

</style>